import React, { useState } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { Button, CircularProgress } from 'design-system';
import { makeStyles } from 'design-system/styles';
import { LAST_UPDATE, LAST_SNOOZE, STAFFING_KEY_PREFIX } from 'corp/views/UpdateStaffingReminder';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface ConfirmationProps {
  user: IUserJson;
  setShow: (show: boolean) => void;
  snoozed: boolean;
  setPopupCounter: (n: any) => void;
  canClose?: boolean;
}

const Confirmation: React.FC<ConfirmationProps> = ({
  user,
  setShow,
  snoozed,
  setPopupCounter,
  canClose,
}) => {
  const styles = useStyles();

  const [isLoading, setIsLoading] = useState(false);

  async function confirm() {
    try {
      setIsLoading(true);
      const lastUpdateTime = await apiFetch(null, 'corp-api/qm/project_roles/last_staffing_time', {
        method: 'POST',
        body: { user: user._id },
      });
      try {
        localStorage.setItem(STAFFING_KEY_PREFIX + LAST_SNOOZE, 'false');
      } catch {
        localStorage.removeItem(STAFFING_KEY_PREFIX + LAST_SNOOZE);
      }
      user.lastStaffingUpdateTime = lastUpdateTime;
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    } finally {
      setIsLoading(false);
      setShow(false);
      setPopupCounter((x: any) => x + 1);
    }
  }

  function dismiss() {
    try {
      localStorage.setItem(STAFFING_KEY_PREFIX + LAST_UPDATE, new Date().toString());
    } catch {
      localStorage.removeItem(STAFFING_KEY_PREFIX + LAST_UPDATE);
    }
    try {
      localStorage.setItem(STAFFING_KEY_PREFIX + LAST_SNOOZE, 'true');
    } catch {
      localStorage.removeItem(STAFFING_KEY_PREFIX + LAST_SNOOZE);
    }

    setShow(false);
    setPopupCounter((x: any) => x + 1);
  }

  return (
    <div className={styles.confirmationWrapper}>
      {isLoading ? (
        <CircularProgress size="24px" color="inherit" />
      ) : (
        <>
          {!snoozed && (
            <div>
              <Button onClick={() => dismiss()} type="tertiary">
                Remind Me Tomorrow
              </Button>
            </div>
          )}
          {canClose && (
            <div>
              <Button onClick={() => confirm()} type="primary">
                Close
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Confirmation;

const useStyles = makeStyles({
  confirmationWrapper: {
    display: 'flex',
    paddingTop: 10,
    '& > div': {
      margin: '5px',
      display: 'flex',
      flex: '1',
    },
    '& > div > button': {
      width: '100%',
      padding: '10px',
    },
  },
});
